import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

// Utility functions
import { cartApi } from '~js/utils/cart-api';
import { getDisplayPrice } from '~js/utils/utils';

const Recommendations = ({
  recommendedProducts,
  cartConfig,
  loading,
  setLoading,
}) => {
  return (
    <div className="-mx-4 mt-6 bg-p-creamSecondary py-4 lg:-mx-6 lg:py-5">
      <h3 className="mb-3 px-4 text-p-darkTeal lg:px-6">
        {cartConfig.recommendations_title}
      </h3>

      {/* Swiper Container */}
      <Swiper
        spaceBetween={12}
        slidesPerView="auto"
        loop={false}
        touchEventsTarget="container"
        className="!px-4 lg:!px-6"
      >
        {recommendedProducts.map((product) => {
          const imageSrc =
            product.variant.featured_image?.src || product.featured_image;
          return (
            <SwiperSlide
              key={product.variant.id}
              className="!h-auto !w-72 lg:!w-[360px]"
            >
              <div className="flex h-full gap-3 rounded-md bg-white p-2 lg:p-3">
                {/* Product Image */}
                {imageSrc ? (
                  <div className="w-16 flex-shrink-0">
                    <a href={product.variant.url}>
                      <img
                        src={imageSrc}
                        alt={product.title}
                        className="h-auto w-full rounded-md"
                      />
                    </a>
                  </div>
                ) : null}

                <div className="flex flex-1 flex-col">
                  {/* Product Title */}
                  <h4 className="mb-1 text-base font-semibold text-p-darkTeal lg:text-lg">
                    <a href={product.variant.url}>{product.title}</a>
                  </h4>

                  {/* Variant Title */}
                  {/* {product.variant.title && (
                    <p className="text-xs text-p-darkTeal lg:text-sm">
                      {product.variant.title.split(' / ').join(' | ')}
                    </p>
                  )} */}

                  {/* Description */}
                  {product.description && (
                    <p
                      className="line-clamp-1 text-xs text-p-darkTeal lg:text-sm"
                      dangerouslySetInnerHTML={{
                        __html: product.description,
                      }}
                    ></p>
                  )}

                  <div className="mt-auto flex items-center justify-between gap-5 pt-2 lg:pt-2.5">
                    {/* Price */}
                    {product.variant.price && (
                      <p className="text-sm font-semibold text-p-darkTeal">
                        {getDisplayPrice(product.variant.price)}
                      </p>
                    )}

                    {/* Add to Cart Button */}
                    <button
                      className="btn inline-flex items-center justify-center px-[9px] py-1 text-center text-xs"
                      onClick={() =>
                        cartApi.addToCart(
                          product.variant.id,
                          1,
                          'add',
                          setLoading,
                        )
                      }
                      disabled={loading?.status === true}
                    >
                      {loading?.variantId === product.variant.id &&
                      loading?.action === 'add'
                        ? cartConfig.recommendations_a2c_text + '...'
                        : cartConfig.recommendations_a2c_text}
                    </button>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Recommendations;
